// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

// Function to detect if we're in an iframe
function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true; // Assume iframe if we can't access window.top
  }
}

// Build WebSocket URL with authentication params if needed
function buildWebSocketUrl() {
  // Check if we're in an iframe and have a session token
  if (isInIframe() && window.canvasSessionToken) {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = window.location.host;
    const token = window.canvasSessionToken;

    // Pass session token as URL parameter for iframe authentication
    return `${protocol}//${host}/cable?session_token=${encodeURIComponent(token)}`;
  }

  // Default behavior - use cookies for authentication
  return undefined; // createConsumer will use default URL
}

export default createConsumer(buildWebSocketUrl())
